import React from 'react'

function listIcon({ color = 'black', bgColor = 'white' }) {
  return (
    <>
      <svg width="24" height="24" viewBox="0 0 24 24" fill={bgColor} xmlns="http://www.w3.org/2000/svg">
        <path d="M12 5.5H21" stroke={color} stroke-linecap="round" />
        <path d="M12 12H21" stroke={color} stroke-linecap="round" />
        <path d="M12 18.5H21" stroke={color} stroke-linecap="round" />
        <path d="M8 5.5H3M4.04167 8L6.95833 3M6.95833 8L4.04167 3" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
        <path d="M8 18.5H3M4.04167 21L6.95833 16M6.95833 21L4.04167 16" stroke={color} stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </>
  )
}

export default listIcon